import { render } from "./GameThreeInstrucctions.vue?vue&type=template&id=bf1a8178"
import script from "./GameThreeInstrucctions.vue?vue&type=script&lang=js"
export * from "./GameThreeInstrucctions.vue?vue&type=script&lang=js"

import "./GameThreeInstrucctions.vue?vue&type=style&index=0&id=bf1a8178&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__